// Import Shared Utils
import { formatCountryCode } from 'shared-components/src/utils/formatCountry';
import { formatCurrencyV } from 'shared-components/src/utils/formatCurrency';

const yesNoOrDash = value => ({ true: 'Y', false: 'N' }[value] ?? '--');

export default [
  {
    Header: 'Errors',
    expander: true,
    width: 64,
  },
  {
    Header: 'External Tag',
    accessor: row => row.cardholder.external_tag,
    id: 'external_tag',
    Cell: ({ value }) => (value.length > 0 ? value : '--'),
  },
  {
    Header: 'First Name',
    accessor: row => row.cardholder.first_name,
    id: 'first_name',
  },
  {
    Header: 'Last Name',
    accessor: row => row.cardholder.last_name,
    id: 'last_name',
  },
  {
    Header: 'Email',
    accessor: row => row.cardholder.email,
    id: 'email',
  },
  {
    Header: 'Date of Birth',
    accessor: row => row.cardholder.date_of_birth,
    id: 'date_of_birth',
  },
  {
    Header: 'Address Line 1',
    accessor: row => row.cardholder.address1,
    id: 'address1',
  },
  {
    Header: 'Postal Code',
    minWidth: 60,
    accessor: row => row.cardholder.postal_code,
    id: 'postal_code',
  },
  {
    Header: 'Country',
    accessor: row => row.cardholder.country,
    id: 'country',
    minWidth: 45,
    Cell: ({ value }) => formatCountryCode(value),
  },
  {
    Header: 'Value Load',
    accessor: row => row.cardholder.load_amount,
    id: 'load_amount',
    Cell: ({ value }) => formatCurrencyV(value / 100),
  },
  {
    Header: 'SIN/SSN',
    accessor: row => row.cardholder.sin,
    id: 'sin',
  },
  {
    Header: 'Office Id',
    accessor: row => row.cardholder.office_id,
    id: 'office_id',
    Cell: ({ value }) => value || '--'
  },
  {
    Header: 'Employer Name',
    accessor: row => row.cardholder.employer_name,
    id: 'employer_name',
    Cell: ({ value }) => value || '--'  },
  {
    Header: 'Occupation',
    accessor: row => row.cardholder.occupation,
    id: 'occupation',
    Cell: ({ value }) => value || '--'  },
  {
    Header: 'Occupation Role',
    accessor: row => row.cardholder.occupation_role,
    id: 'occupation_role',
    Cell: ({ value }) => value || '--'  },
  {
    Header: 'Occupation Sector',
    accessor: row => row.cardholder.occupation_sector,
    id: 'occupation_sector',
    Cell: ({ value }) => value || '--'  },
  {
    Header: 'Sole Proprietor',
    accessor: row => row.cardholder.is_sole_proprietor,
    id: 'is_sole_proprietor',
    Cell: ({ value }) => yesNoOrDash(value)  },
  {
    Header: 'Occupation Detail',
    accessor: row => row.cardholder.occupation_other_detail,
    id: 'occupation_other_detail',
    Cell: ({ value }) => value || '--'  },
  {
    Header: 'Non Resident Alien',
    accessor: row => row.cardholder.non_resident_alien,
    id: 'non_resident_alien',
    Cell: ({ value }) => value === true ? 'Y' : value === false ? 'N' : '--'  },
  {
    Header: 'Politically Exposed Person',
    accessor: row => row.cardholder.politically_exposed_person,
    id: 'politically_exposed_person',
    Cell: ({ value }) => value === true ? 'Y' : value === false ? 'N' : '--'  },
  {
    Header: 'Primary Source Of Funds',
    accessor: row => row.cardholder.primary_source_of_funds,
    id: 'primary_source_of_funds',
    Cell: ({ value }) => value || '--'
  },  {
    Header: 'Primary Use Of Account',
    accessor: row => row.cardholder.primary_use_of_account,
    id: 'primary_use_of_account',
    Cell: ({ value }) => value || '--'  },
  {
    Header: 'Country Of Citizenship',
    accessor: row => row.cardholder.country_of_citizenship,
    id: 'country_of_citizenship',
    Cell: ({ value }) => value || '--'  },
];
